import { LOGIN_REDIRECT, GET_USER_INFO, POST_USER_LOGOUT, POST_REFRESH_TOKEN, POST_UPDATE_USER_PIC, GET_USER_PIC, PUT_UPDATE_USER_INFO, BUY_CREDIT, CREATE_CHECKOUT_SESSION, CREATE_SUBSCRIPTION, GET_MY_SUBSCRIPTIONS, GET_SUBSCRIPTION_USAGE, GET_SUBSCRIPTION_BY_ID, CANCEL_SUBSCRIPTION, UPDATE_SUBSCRIPTION, GET_CHARGEBEE_PORTAL, GET_SUBSCRIPTION_PLANS } from '../../config/endpoints';
import { setAlertMessage, setAlertType } from '../reducers/alertSlice';
import { setIsLoginDialog } from '../reducers/loginSlice';
import { clear_User } from '../reducers/userSlice';

import * as USER_ACTION from "../reducers/userSlice";

const isUpdateProfileLink = () => {
    if (typeof window === 'undefined') return false;
    const hash = String(window.location?.hash || '');
    return hash.includes('update-profile') && hash.includes('biginId=');
};

const bypassAuthRedirect = (dispatch) => {
    if (!isUpdateProfileLink()) return false;
    try { dispatch(setIsLoginDialog(false)); } catch { }
    return true;
};

export const getUserProfile = (jwtToken) => {
    console.log("HITTING - getUserProfile", jwtToken);
    return dispatch => {
        dispatch(USER_ACTION.isStarted_GetProfile());
        const apiUrl = new URL(GET_USER_INFO);
        fetch(apiUrl, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${jwtToken}`
            },
        })
            .then(res => {
                if (!res.ok) {
                    if (res.status === 401) {
                        if (bypassAuthRedirect(dispatch)) {
                            return Promise.reject(new Error('Unauthorized for update profile'));
                        }
                        const isPlayground = (typeof window !== 'undefined') && String(window.location?.hash || '').includes('#/playground');
                        const hasToken = (() => { try { return !!localStorage.getItem('BQS_TOKEN'); } catch { return false; } })();
                        if (isPlayground && !hasToken) {
                            return Promise.reject(new Error('Unauthorized on public route'));
                        }
                        return refreshToken(jwtToken)
                            .then(r => r.json())
                            .then(resp => {
                                if (resp && resp.code === 200 && resp?.data?.token?.token) {
                                    try { localStorage.setItem('BQS_TOKEN', resp.data.token.token); } catch { }
                                    dispatch(getUserProfile(resp.data.token.token));
                                    return Promise.reject(new Error('Retried after refresh'));
                                }
                                if (!bypassAuthRedirect(dispatch)) {
                                    window.location = LOGIN_REDIRECT;
                                    dispatch(setIsLoginDialog(true));
                                    try { localStorage.clear(); } catch { }
                                }
                                return Promise.reject(new Error('Unauthorized after refresh'));
                            })
                            .catch(() => {
                                if (!bypassAuthRedirect(dispatch)) {
                                    window.location = LOGIN_REDIRECT;
                                    dispatch(setIsLoginDialog(true));
                                    try { localStorage.clear(); } catch { }
                                }
                                return Promise.reject(new Error('Unauthorized after refresh (catch)'));
                            });
                    } else {
                        throw new Error(res.statusText);
                    }
                }
                return res.json();
            })
            .then(response => {
                if (!response || !response.hasOwnProperty('code') || response.code !== 200) {
                    throw new Error('Server error: ' + response.message);
                }
                console.log(response.data.exclusiveFeaturesList);
                localStorage.setItem("exclusiveFeaturesEnabled", response.data.exclusiveFeaturesList.map(feature => feature.exclusiveFeatureName));
                dispatch(USER_ACTION.success_GetProfile(response.data));
            })
            .catch(error => {
                dispatch(USER_ACTION.error_GetProfile(error.message));
            });
    }
}

export const UpdateUserProfile = (jwtToken, formData) => {
    return dispatch => {
        dispatch(USER_ACTION.isStarted_UpdateProfile());
        const apiUrl = new URL(PUT_UPDATE_USER_INFO);
        return fetch(apiUrl, {
            method: "POST",
            headers: {
                "Authorization": `Bearer ${jwtToken}`,
                "Content-Type": "Application/json"
            },
            body: JSON.stringify(formData)
        }).then(res => {
            if (!res.ok) {
                if (res.status === 401) {
                    if (!bypassAuthRedirect(dispatch)) {
                        window.location = LOGIN_REDIRECT;
                        dispatch(setIsLoginDialog(true))
                        localStorage.clear()
                        dispatch(clear_User())
                    }
                    return Promise.reject(new Error('Unauthorized'));
                }
                throw new Error(res.statusText);
            }
            return res.json().catch(() => ({}));
        }).then(response => {
            if (response && response.code === 200) {
                dispatch(USER_ACTION.success_GetProfile(response.data));
                return { success: true, data: response.data };
            }
            const message = response?.message || 'Unable to update profile.';
            dispatch(setAlertMessage(message))
            dispatch(setAlertType("error"))
            return { success: false, message };
        }).catch(error => {
            dispatch(USER_ACTION.error_GetProfilePic(error.message));
            dispatch(setAlertType("error"))
            throw error;
        });
    }
}

export const getUserProfilePic = (jwtToken, isRetry = false) => {
    return dispatch => {
        dispatch(USER_ACTION.isStarted_GetProfilePic());
        const apiUrl = new URL(`${GET_USER_PIC}?t=${Date.now()}`);
        fetch(apiUrl, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${jwtToken}`,
            },
            cache: 'no-store',
        })
            .then(res => {
                if (!res.ok) {
                    if (res.status === 404) {
                        dispatch(USER_ACTION.success_GetProfilePic(null));
                        return null;
                    }
                    if (res.status === 401) {
                        if (bypassAuthRedirect(dispatch)) {
                            return Promise.reject(new Error('Unauthorized for update profile'));
                        }
                        const isPlayground = (typeof window !== 'undefined') && String(window.location?.hash || '').includes('#/playground');
                        const hasToken = (() => { try { return !!localStorage.getItem('BQS_TOKEN'); } catch { return false; } })();
                        if (isPlayground && !hasToken) {
                            return Promise.reject(new Error('Unauthorized on public route'));
                        }
                        return refreshToken(jwtToken)
                            .then(r => r.json())
                            .then(resp => {
                                if (resp && resp.code === 200 && resp?.data?.token?.token) {
                                    const newTok = resp.data.token.token;
                                    try { localStorage.setItem('BQS_TOKEN', newTok); } catch { }
                                    const bust = new URL(`${GET_USER_PIC}?t=${Date.now()}`);
                                    return fetch(bust, {
                                        method: 'GET',
                                        headers: {
                                            'Authorization': `Bearer ${newTok}`,
                                        }
                                    });
                                }
                                if (!bypassAuthRedirect(dispatch)) {
                                    window.location = LOGIN_REDIRECT;
                                    dispatch(setIsLoginDialog(true));
                                    try { localStorage.clear(); } catch { }
                                }
                                return Promise.reject(new Error('Unauthorized after refresh'));
                            })
                            .then(r2 => {
                                if (!r2 || !r2.ok) throw new Error('Retry failed');
                                return r2.blob();
                            })
                            .then(blob => {
                                if (blob.size === 0) throw new Error('Empty response received');
                                const file = new File([blob], 'image', { type: 'image/jpeg' });
                                const fr = new FileReader();
                                fr.readAsDataURL(file);
                                fr.addEventListener('load', () => {
                                    const res64 = fr.result;
                                    dispatch(USER_ACTION.success_GetProfilePic(res64));
                                });
                                return Promise.reject(new Error('handled'));
                            })
                            .catch((e) => {
                                if (String(e?.message || '') === 'handled') return Promise.reject(e);
                                if (!bypassAuthRedirect(dispatch)) {
                                    window.location = LOGIN_REDIRECT;
                                    dispatch(setIsLoginDialog(true));
                                    try { localStorage.clear(); } catch { }
                                }
                                return Promise.reject(new Error('Unauthorized after refresh (catch)'));
                            });
                    } else {
                        throw new Error(res.statusText);
                    }
                }
                return res.blob()
            })
            .then(blob => {
                if (blob === null) return;
                if (blob.size === 0) {
                    if (isRetry) {
                        // Stop retrying, treat as no image
                        const fr = new FileReader(); // Just to be safe or just dispatch null
                        // Actually just dispatch success with empty result or handled
                        return dispatch(USER_ACTION.success_GetProfilePic(null));
                    }
                    return dispatch(refreshUserProfilePicWithRetry(jwtToken, 2, 600));
                }
                const file = new File([blob], 'image', { type: "image/jpeg" })
                const fr = new FileReader()
                fr.readAsDataURL(file)
                fr.addEventListener("load", () => {
                    const res = fr.result
                    dispatch(USER_ACTION.success_GetProfilePic(res));
                })
            })
            .catch(error => {
                console.error(error.message);
                dispatch(USER_ACTION.error_GetProfilePic(error.message));
            });
    }
}

export const refreshUserProfilePicWithRetry = (jwtToken, attempts = 3, delayMs = 600) => {
    return async (dispatch, getState) => {
        const getUrl = () => (getState()?.user?.profilePic?.profilePicUrl || '');
        const prevUrl = getUrl();
        for (let i = 0; i < attempts; i++) {
            await dispatch(getUserProfilePic(jwtToken, true));
            await new Promise((r) => setTimeout(r, delayMs));
            const curUrl = getUrl();
            if (curUrl && curUrl !== prevUrl) break;
        }
    };
};

export const UpdateUserProfilePic = (jwtToken, file) => {
    console.log("HITTING - UpdateUserProfilePic", jwtToken);
    return dispatch => {
        if (!file || !Number.isFinite(file.size) || file.size <= 0) {
            dispatch(setAlertMessage("Invalid image file"));
            dispatch(setAlertType("error"));
            return;
        }
        dispatch(USER_ACTION.isStarted_GetProfilePic());
        const apiUrl = new URL(POST_UPDATE_USER_PIC);
        return fetch(apiUrl, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${jwtToken}`,
                filename: file.name,
                streamsize: String(file.size),
            },
            body: file,
        })
            .then(res => {
                if (!res.ok) throw new Error(res.statusText || 'Upload failed');
                return res.json().catch(() => ({}));
            })
            .then(response => {
                if ((response && response.code === 200) || (response && typeof response === 'object' && Object.keys(response).length === 0)) {
                    return dispatch(getUserProfilePic(jwtToken));
                }
                dispatch(setAlertMessage(response.message || 'Upload failed'))
                dispatch(setAlertType("error"))
                return dispatch(getUserProfilePic(jwtToken))
            })
            .catch((error) => {
                const msg = error?.message || 'Upload failed';
                dispatch(setAlertMessage(msg))
                dispatch(setAlertType("error"))
            });
    }
}

export const userLogout = (jwtToken) => {
    const apiUrl = new URL(POST_USER_LOGOUT);
    const logoutResponse = fetch(apiUrl, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${jwtToken}`
        },
    })
    return logoutResponse
}

export const refreshToken = (jwtToken) => {
    const apiUrl = new URL(POST_REFRESH_TOKEN);
    const refreshTokenResponse = fetch(apiUrl, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${jwtToken}`
        },
    })
    return refreshTokenResponse
}

export const buyReviewCredits = async (jwtToken) => {
    try {
        const url = `${BUY_CREDIT}`;
        const apiUrl = new URL(url);
        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${jwtToken}`,
            },
        });

        if (response.status === 401) {
            localStorage.clear();
            return { code: 401, message: "Unauthorized" };
        }

        const result = await response.json();
        return result;

    } catch (error) {
        console.error('buyReviewCredits error:', error);
        return { code: 500, message: "Internal Server Error" };
    }
};

export const initiateCheckout = async (jwtToken, planId, profileData, redirectUrl, cancelUrl) => {
    try {
        const apiUrl = new URL(CREATE_CHECKOUT_SESSION);
        
        const payload = {
            planId: planId,
            email: profileData?.email,
            firstName: typeof profileData?.name === 'object' ? profileData?.name?.firstName : profileData?.name,
            lastName: typeof profileData?.name === 'object' ? profileData?.name?.lastName : '',
            phone: profileData?.phone,
            ...(redirectUrl && { redirectUrl }),
            ...(cancelUrl && { cancelUrl })
        };

        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
            body: JSON.stringify(payload)
        });

        if (response.status === 401) {
            localStorage.clear();
            return { code: 401, message: "Unauthorized" };
        }

        const result = await response.json();
        return result;

    } catch (error) {
        console.error('initiateCheckout error:', error);
        return { code: 500, message: "Internal Server Error" };
    }
};

// ─── Subscription API (new) ────────────────────────────────────────────────

export const getSubscriptionPlans = async (productLine) => {
    try {
        const url = productLine
            ? `${GET_SUBSCRIPTION_PLANS}?productLine=${productLine}`
            : GET_SUBSCRIPTION_PLANS;
        const response = await fetch(url, { method: 'GET' });
        const result = await response.json();
        return result;
    } catch (error) {
        console.error('getSubscriptionPlans error:', error);
        return { code: 500, message: 'Internal Server Error' };
    }
};

export const createSubscription = async (jwtToken, planId) => {
    try {
        const response = await fetch(CREATE_SUBSCRIPTION, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
            body: JSON.stringify({ planId }),
        });
        if (response.status === 401) {
            localStorage.clear();
            return { code: 401, message: 'Unauthorized' };
        }
        return await response.json();
    } catch (error) {
        console.error('createSubscription error:', error);
        return { code: 500, message: 'Internal Server Error' };
    }
};

export const fetchMySubscriptions = (jwtToken, status = 'active', forceRefresh = false) => {
    return async (dispatch, getState) => {
        const state = getState();
        // Prevent redundant calls unless forceRefresh is true
        // Also skip if we already have a value (null means not fetched yet)
        if (!forceRefresh && (state.user.subscriptions.isStarted || state.user.subscriptions.value !== null)) return;

        dispatch(USER_ACTION.isStarted_GetSubscriptions());
        try {
            // Add timestamp for cache-busting
            // We omit the status query param so we can fetch all subscriptions
            // and filter them locally. This allows us to treat cancelled subscriptions
            // that haven't yet expired as 'active'.
            const url = new URL(GET_MY_SUBSCRIPTIONS);
            url.searchParams.append('_t', String(Date.now()));

            const response = await fetch(url, {
                method: 'GET',
                headers: { 
                    'Authorization': `Bearer ${jwtToken}`,
                    'Cache-Control': 'no-cache',
                    'Pragma': 'no-cache'
                },
                cache: 'no-store'
            });
            if (response.status === 401) {
                localStorage.clear();
                dispatch(USER_ACTION.error_GetSubscriptions('Unauthorized'));
                dispatch(USER_ACTION.error_GetAllSubscriptions('Unauthorized'));
                return;
            }
            const result = await response.json();
            if (result && result.code === 200) {
                let validSubs = Array.isArray(result.data) ? result.data : [];
                // Sort by createdAt descending to ensure most recent is primary
                validSubs.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
                
                // Dispatch all raw subscriptions
                dispatch(USER_ACTION.success_GetAllSubscriptions(validSubs));
                
                // If the app requested "active" subscriptions, filter them logically
                if (status === 'active') {
                    const nowMs = Date.now();
                    validSubs = validSubs.filter(sub => {
                        const rawStatus = sub.status || sub.state || '';
                        const subStatus = String(rawStatus || '').trim().toLowerCase();
                        const isScheduledForCancel = !!sub.pendingCancelAt || subStatus.includes('cancel') || subStatus === 'non_renewing';
                        
                        if (subStatus === 'active' && !isScheduledForCancel) return true;
                        if (isScheduledForCancel) {
                             const endVal = sub.currentTermEnd || sub.billingPeriod?.end || sub.expiresAt;
                             if (!endVal) return false;
                             
                             let termEndMs = 0;
                             if (typeof endVal === 'string' && isNaN(Number(endVal))) {
                                 termEndMs = new Date(endVal).getTime();
                             } else {
                                 const numericEnd = Number(endVal);
                                 termEndMs = String(numericEnd).length <= 10 ? numericEnd * 1000 : numericEnd;
                             }
                             
                             return termEndMs > nowMs;
                        }
                        return false;
                    });
                }
                
                dispatch(USER_ACTION.success_GetSubscriptions(validSubs));
            } else {
                dispatch(USER_ACTION.error_GetSubscriptions(result.message || 'Failed to load subscriptions.'));
                dispatch(USER_ACTION.error_GetAllSubscriptions(result.message || 'Failed to load subscriptions.'));
            }
        } catch (error) {
            console.error('fetchMySubscriptions error:', error);
            dispatch(USER_ACTION.error_GetSubscriptions(error.message || 'Internal Server Error'));
            dispatch(USER_ACTION.error_GetAllSubscriptions(error.message || 'Internal Server Error'));
        }
    };
};

export const fetchSubscriptionUsage = (jwtToken, productLine = "smartInsights") => {
    return async (dispatch, getState) => {
        try {
            // Guard: don't fetch if already started
            const state = getState();
            if (state.user.subscriptionUsage.isStarted) return;

            dispatch(USER_ACTION.isStarted_GetSubscriptionUsage());
            const result = await getSubscriptionUsage(jwtToken, productLine);
            if (result?.code === 200 && result.data) {
                dispatch(USER_ACTION.success_GetSubscriptionUsage(result.data));
            } else {
                dispatch(USER_ACTION.error_GetSubscriptionUsage(result.message || 'Failed to load usage.'));
            }
        } catch (error) {
            console.error('fetchSubscriptionUsage error:', error);
            dispatch(USER_ACTION.error_GetSubscriptionUsage(error.message || 'Internal Server Error'));
        }
    };
};

export const getMySubscriptions = async (jwtToken, status) => {
    try {
        const url = status
            ? `${GET_MY_SUBSCRIPTIONS}?status=${status}`
            : GET_MY_SUBSCRIPTIONS;
        const response = await fetch(url, {
            method: 'GET',
            headers: { 'Authorization': `Bearer ${jwtToken}` },
        });
        if (response.status === 401) {
            localStorage.clear();
            return { code: 401, message: 'Unauthorized' };
        }
        return await response.json();
    } catch (error) {
        console.error('getMySubscriptions error:', error);
        return { code: 500, message: 'Internal Server Error' };
    }
};

export const getSubscriptionUsage = async (jwtToken, productLine) => {
    try {
        const timestamp = Date.now();
        const separator = productLine ? '&' : '?';
        const url = `${GET_SUBSCRIPTION_USAGE}${productLine ? `?productLine=${productLine}` : ''}${separator}_t=${timestamp}`;
        const response = await fetch(url, {
            method: 'GET',
            headers: { 
                'Authorization': `Bearer ${jwtToken}`,
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache'
            },
            cache: 'no-store'
        });
        if (response.status === 401) {
            localStorage.clear();
            return { code: 401, message: 'Unauthorized' };
        }
        return await response.json();
    } catch (error) {
        console.error('getSubscriptionUsage error:', error);
        return { code: 500, message: 'Internal Server Error' };
    }
};

export const getSubscriptionById = async (jwtToken, subscriptionId) => {
    try {
        const response = await fetch(GET_SUBSCRIPTION_BY_ID(subscriptionId), {
            method: 'GET',
            headers: { 'Authorization': `Bearer ${jwtToken}` },
        });
        if (response.status === 401) {
            localStorage.clear();
            return { code: 401, message: 'Unauthorized' };
        }
        return await response.json();
    } catch (error) {
        console.error('getSubscriptionById error:', error);
        return { code: 500, message: 'Internal Server Error' };
    }
};

export const cancelSubscription = async (jwtToken, subscriptionId, reason) => {
    try {
        const response = await fetch(CANCEL_SUBSCRIPTION(subscriptionId), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
            body: JSON.stringify({ reason: reason || '' }),
        });
        if (response.status === 401) {
            localStorage.clear();
            return { code: 401, message: 'Unauthorized' };
        }
        return await response.json();
    } catch (error) {
        console.error('cancelSubscription error:', error);
        return { code: 500, message: 'Internal Server Error' };
    }
};

export const updateSubscription = async (jwtToken, subscriptionId, body) => {
    try {
        const response = await fetch(UPDATE_SUBSCRIPTION(subscriptionId), {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
            body: JSON.stringify(body),
        });
        if (response.status === 401) {
            localStorage.clear();
            return { code: 401, message: 'Unauthorized' };
        }
        return await response.json();
    } catch (error) {
        console.error('updateSubscription error:', error);
        return { code: 500, message: 'Internal Server Error' };
    }
};

export const getChargebeePortal = async (jwtToken, chargebeeCustomerId) => {
    try {
        const response = await fetch(GET_CHARGEBEE_PORTAL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            }
        });
        if (response.status === 401) {
            localStorage.clear();
            return { code: 401, message: 'Unauthorized' };
        }
        return await response.json();
    } catch (error) {
        console.error('getChargebeePortal error:', error);
        return { code: 500, message: 'Internal Server Error' };
    }
};
